export const ConfigKey_Fishbone_Defaults = 'fishbone__defaults';
//# sourceMappingURL=app-configs.js.map